import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { Component, Inject, Mixins, Prop, Watch } from "vue-property-decorator";
import { IComment, ICommentPayload } from "../types";
import VEmtptyState from "@/vuetify-extensions/VEmptyState.vue";
import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { namespace } from "vuex-class";
import { datetime } from "@/utils/time";
import { EServices } from "@/types";
import TransactionsClient from "../services/TransactionsClient";

const OrderModule = namespace("OrderModule");

@Component({
  components: {
    VEmtptyState,
  },
})
export default class Comments extends Mixins(JackocoinsNetworkManagerMixin) {
  @Prop({
    type: () => [Array, null],
    required: true,
  })
  comments!: null | IComment[];

  @Prop({
    type: Number,
    required: true,
  })
  transactionId!: number;

  commentText = "";

  @Inject(EServices.transactions)
  transactionsClient!: TransactionsClient;

  datetime = datetime;

  @throwsNetworkError()
  async sendComment() {
    if (!this.commentText) return;
    await this.transactionsClient.commentOnTransaction({
      body: this.commentText,
      id: this.transactionId,
    });
    this.commentText = "";
    this.$emit("reload");
  }

  close() {
    this.$emit("close");
  }

  @Watch("comments")
  scrollToBottom() {
    if (!this.comments) return;
    setTimeout(() => {
      const scrollable = document.querySelector(".scrollable")!;
      const scrollHeight = document.querySelector(".scrollable")!.scrollHeight;
      scrollable.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }, 200);
  }

  @Watch("error.sendComment")
  onError(message?: string) {
    if (message)
      toast({ icon: "mdi-exclamation-thick", iconColor: "red", message });
  }

  mounted() {
    this.scrollToBottom();
  }
}
